// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { DateRangeType } from '@res/ng-data-access';
import { TypesaurusCoreDoc } from '@res/ngg-core';
import { AdvancedFilterModel, FilterModel, IServerSideGetRowsRequest } from 'ag-grid-community';
import { ServicingUpdateData, TransactionDef, ServicingRef } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ServicingActions {
  export class GetAllServicings {
    static readonly type = '[Servicing] GetAllServicing';
    readonly type = GetAllServicings.type;
  }

  export class InitServicingCount {
    static readonly type = '[Servicing] InitServicingsCount';
    readonly type = InitServicingCount.type;
  }

  export class InitServicing {
    static readonly type = '[Servicing] InitServicings';
    readonly type = InitServicing.type;
  }
  export class CountServicings {
    static readonly type = '[Servicing] CountServicings';
    readonly type = CountServicings.type;
  }

  export class CloseServicingsConnection {
    static readonly type = '[Servicing] CloseServicingsConnection';
    readonly type = CloseServicingsConnection.type;
  }

  export class GetServicingById {
    static readonly type = '[Servicing] GetServicingById';
    readonly type = GetServicingById.type;
  }

  export class UpdateServicing {
    static readonly type = '[Servicing] UpdateServicing';
    constructor(
      public servicingData: Partial<ServicingUpdateData>,
      public ref: ServicingRef,
    ) {}
  }

  export class DeleteServicings {
    static readonly type = '[Servicing] DeleteServicings';
    constructor(public refs: ServicingRef[]) {}
  }

  export class PaginateQueryServicing {
    static readonly type = '[Servicing] PaginateQueryServicing';
    constructor(
      public request: IServerSideGetRowsRequest,
      public isResetAfterFilterOrSort = false,
      public servicingId?: string,
    ) {}
  }
  export class ServicingError {
    static readonly type = '[Servicing] ServicingError';
    constructor(public error: Error) {}
  }

  export class GetSumOf {
    static readonly type = '[Servicing] GetSumOf';
    constructor(
      public field: string,
      public timePeriod: DateRangeType,
    ) {}
  }
  export class GetSumsCountOf {
    static readonly type = '[Servicing] GetSumsCountOf';
    constructor(
      public fields: {
        sumId: string;
        countId: string;
        countValue: number | string | boolean | Date;
      }[],
      public timePeriod: DateRangeType,
      public filterModel?: FilterModel | AdvancedFilterModel | null,
      public servicingId?: string,
    ) {}
  }

  export class UpdateServicingResult {
    static readonly type = '[Servicing] UpdateServicingResult';
    constructor(public data: Array<TypesaurusCoreDoc<TransactionDef> | null | undefined>) {}
  }
}
